import {ToolbarButton} from "app/Interface/Component/Buttons"
import React from "react"
import {Button} from "react-bootstrap"
import {useTranslation} from "react-i18next"

function SaveButton({id, onClick, disabled, title, variant}: ToolbarButton) {
  const {t} = useTranslation('Components.Buttons')
  return (
    <Button
      id={`save-${id}`}
      onClick={onClick}
      variant={variant ?? 'success'}
      disabled={disabled}
    >
      {t('save')}{title && " "+title}
    </Button>
  )
}

export default SaveButton
